export default "__VITE_ASSET__abf72254__"